<div class="content-dialog">
    <div class="dialog-header">
        <span>ENROLAMIENTO</span>
        <button type="button" class="dialog-header__close" [mat-dialog-close]="data" aria-label="Cerrar">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="dialog-body">

        <div class="intro-banner">
            <span class="intro-banner__icon"><mat-icon>people</mat-icon></span>
            <div class="intro-banner__text">
                <div class="intro-banner__title">Búsqueda de Trabajador</div>
                <div class="intro-banner__subtitle">Seleccione el proyecto y contrato para iniciar el proceso de enrolamiento.</div>
            </div>
        </div>

        <div class="section-label">
            <span class="section-label__icon"><mat-icon>business</mat-icon></span>
            <span>PROYECTO O LUGAR DE TRABAJO</span>
        </div>
        <div class="info-card" *ngFor="let proyect of proyectSelected">
            <img class="info-card__img" src="{{s3Bucket+getImg(proyect.Logo)}}" alt="" (error)="commonMetodService._getUrlErrorImg('project', $event)">
            <div class="info-card__body">
                <h3 class="info-card__title">{{(proyect.Name | uppercase) || ''}}</h3>
                <div class="info-card__field">{{proyect.CompanyName || ''}}</div>
                <div class="info-card__field">{{proyect.CompanyDocNum || ''}}</div>
            </div>
            <button type="button" class="info-card__action" (click)="setValue()" aria-label="Cambiar proyecto">
                <mat-icon>close</mat-icon>
            </button>
        </div>
        <app-select-search class="select-component" style="top: -6px !important;"  *ngIf="proyectSelected.length !== 1 && proyects.length !== 0"
                        [_dataSource]="proyects" [textInput]="''" [placeholder]="'Seleccione para buscar el proyecto'" [inputType]="'text'"
                        [dataShow]="'Name'" [dataValue]="'Id'" [otherFilter]="'CompanyDocNum'" [siteCtrl]="controlEmployer"
                        [isCard]="true"
                        [card]="{img: 'Logo', title: 'Name', subTitle: 'CompanyName', finalLeft:'CompanyDocNum'}"
                        (onSelectionChange)="valueSelectedProyect($event)"
                        [onErrorUrl]="'project'">
        </app-select-search>
        <div class="notice-banner notice-banner--warning" *ngIf="flagExitproyects === true">
            <span class="notice-banner__icon"><mat-icon>info</mat-icon></span>
            <span>Su usuario no esta vinculado a ningún proyecto activo, comuníquese con el usuario operador.</span>
        </div>
        <div class="posgress" *ngIf="flagExitproyects === undefined">
            <h4>CARGANDO PROYECTOS</h4>
            <mat-progress-bar mode="query" [value]="20"></mat-progress-bar>
        </div>

        <div class="section-label">
            <span class="section-label__icon"><mat-icon>description</mat-icon></span>
            <span>CONTRATO</span>
        </div>
        <div class="info-card" *ngFor="let contract of contractsSelected">
            <img class="info-card__img" src="{{s3Bucket+getImg(contract.FormImageLogo)}}" alt="">
            <div class="info-card__body">
                <h3 class="info-card__title">{{(contract.ContractReview | uppercase) || ''}}</h3>
                <div class="info-card__field">{{contract.ContractorName}}</div>
                <div class="info-card__field">{{contract.ContractNumber}}</div>
            </div>
            <button type="button" class="info-card__action" (click)="setValueContract()" aria-label="Cambiar contrato">
                <mat-icon>close</mat-icon>
            </button>
        </div>
        <app-select-search class="select-component" *ngIf="proyectSelected.length === 1 && contractsSelected.length === 0"
                        [_dataSource]="contracts" [textInput]="''" [placeholder]="'Seleccione para buscar el contrato'" [inputType]="'text'"
                        [dataShow]="'ContractorName'" [dataValue]="'Id'" [otherFilter]="'ContractorDocumentNumber'" [siteCtrl]="controlContractSelected"
                        [isCard]="true"
                        [card]="{img: 'FormImageLogo', title: 'ContractReview', subTitle: 'ContractorName', finalLeft: 'ContractNumber'}"
                        (onSelectionChange)="onSelectionChangeContract($event)">
        </app-select-search>
        <div class="notice-banner notice-banner--warning" *ngIf="flagExitContractContracts === false">
            <span class="notice-banner__icon"><mat-icon>info</mat-icon></span>
            <span>No se encontro un contrato activo en este proyecto. Comuniquese con el operador del proyecto.</span>
        </div>

        <div class="section-label">
            <span class="section-label__icon"><mat-icon>person</mat-icon></span>
            <span>EMPLEADO O CONTRATADO</span>
        </div>
        <div class="info-card" *ngFor="let personal of personalSelected">
            <img class="info-card__img" src="{{s3Bucket+getImgEmp(personal.Photo)}}" (error)="commonMetodService._getUrlErrorImg('personal', $event)" alt="">
            <div class="info-card__body">
                <h3 class="info-card__title">{{(personal.Name | uppercase) || ''}} {{(personal.LastName | uppercase) || ''}}</h3>
                <div class="info-card__field">{{personal.DocumentType}}: {{personal.DocumentNumber || ''}}</div>
            </div>
            <button type="button" class="info-card__action" (click)="setValuePersonal()" aria-label="Cambiar empleado">
                <mat-icon>close</mat-icon>
            </button>
        </div>

        <div class="search-row" *ngIf="proyectSelected.length === 1 && contractsSelected.length === 1 && personalSelected.length !== 1">
            <div class="field-box search-field--type">
                <span class="field-box__label">TIPO DE DOCUMENTO</span>
                <div class="field-box__control">
                    <mat-icon class="field-box__icon">person_outline</mat-icon>
                    <mat-form-field>
                        <mat-select [(ngModel)]="documentType" (selectionChange)="changeType($event.value)">
                            <mat-option *ngFor="let data of companyDocumentType" [value]="data.Value">
                                {{(data.Description === 'C.C.' ? 'Cedula': data.Description)}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="field-box search-field--number">
                <span class="field-box__label">NÚMERO DE DOCUMENTO</span>
                <div class="field-box__control">
                    <mat-icon class="field-box__icon">label</mat-icon>
                    <mat-form-field>
                        <input matInput type="text" [(ngModel)]="documentNumber" pattern="/^-?\d+\.?\d*$/" maxlength="{{maxCaracter}}" oninput="this.value = this.value.replace(/[^Z0-9]/,'')">
                    </mat-form-field>
                    <button type="button" class="field-box__clear" aria-label="Limpiar" (click)="setValuePersonal()">
                        <mat-icon>close</mat-icon>
                    </button>
                </div>
            </div>
            <button mat-mini-fab class="search-row__btn" matTooltip="buscar" (click)="getPersonalDocument()">
                <mat-icon>search</mat-icon>
            </button>
        </div>

        <div class="notice-banner" *ngIf="proyectSelected.length === 1 && contractsSelected.length === 1 && personalSelected.length !== 1">
            <span class="notice-banner__icon"><mat-icon>info</mat-icon></span>
            <span>Si el trabajador no se encuentra registrado, el sistema le permitirá iniciar un nuevo flujo de captura de datos después de la búsqueda fallida.</span>
        </div>

        <div class="actions-dialog">
            <button mat-stroked-button class="btn-cancelar" [mat-dialog-close]="data">CANCELAR</button>
            <button mat-button *ngIf="data.IsRequest !== true"
                    (click)="iniciar()"
                    [ngClass]="getDisabled() === true ? 'btn-generar':'btn-disabled'"
                    [disabled]="!getDisabled()">INICIAR
            </button>
        </div>
    </div>
</div>
